var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 276,
    viewBox: "0 0 306 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 89.8V0.5H305.4V89.8H264.3V41.5H41.7001V89.8H0.600098Z",
    fill: "#212144"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.1 180H199V234.5H173.7V66.6H132.6V234.5H106.4V180H65.3003V275.5H132.6H173.7H240.1V180Z",
    fill: "#212144"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 114.7H0.700195V155.7H106.4V114.7Z",
    fill: "#AA996D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.3 114.7H199.6V155.7H305.3V114.7Z",
    fill: "#AA996D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalLogoLight);
export default __webpack_public_path__ + "static/media/legal-logo-light.6369ce78d7c0d7c00206865eb748408b.svg";
export { ForwardRef as ReactComponent };